import { CaretDownFilled, CaretLeftFilled } from '@ant-design/icons'
import { Tag } from 'antd'
import { inject, observer } from 'mobx-react'
import React, { useState } from 'react'
import FileItem from '../../../components/Common/FileItemComponent/FileItem'
import ContentBlockWrapper from '../../../components/ContentBlockWrapper'
import utils from '../../../utils'

const FeedbackCommentSection = props => {
  const {
    selectedIndex,
    feedbackCommentDataDetailV2,
    getNameUppercaseByUsername,
  } = props

  const [showDeletedComments] = useState(false)
  const [isCommentListOpen, setIsCommentListOpen] = useState(true)

  if (!selectedIndex || !feedbackCommentDataDetailV2?.feedbackCommentDetails) {
    return null
  }

  const displayComments = feedbackCommentDataDetailV2.feedbackCommentDetails
    .filter(comment => {
      const hasContent =
        comment.detailFeedbackComment &&
        comment.detailFeedbackComment.trim() !== ''
      const shouldShowDeleted = showDeletedComments || !comment.isDeleted
      return hasContent && shouldShowDeleted
    })
    .sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt))

  return (
    <ContentBlockWrapper style={{ marginBottom: 20 }}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          fontWeight: 500,
          fontSize: 14,
          margin: '-16px -16px 10px -16px',
          borderTopLeftRadius: 6,
          borderTopRightRadius: 6,
          padding: '10px 16px',
          color: '#fff',
          backgroundColor: '#2C65AC',
          cursor: 'pointer',
        }}
        onClick={() => setIsCommentListOpen(!isCommentListOpen)}>
        <span>Danh sách ý kiến</span>
        <div onClick={() => setIsCommentListOpen(!isCommentListOpen)}>
          {isCommentListOpen ? <CaretDownFilled /> : <CaretLeftFilled />}
        </div>
      </div>

      <div
        style={{
          overflow: 'hidden',
          maxHeight: isCommentListOpen ? '2500px' : '0',
          opacity: isCommentListOpen ? 1 : 0,
          transition:
            'max-height 0.5s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.4s ease',
        }}>
        <div
          style={{
            maxHeight: '500px',
            overflow: 'auto',
            marginBottom: '10px',
            paddingRight: '10px',
          }}>
          {displayComments.length > 0 ? (
            displayComments.map(comment => {

              return (
                <div
                  key={comment.id}
                  style={{
                    marginBottom: '10px',
                    padding: '5px 0',
                    borderBottom: '1px solid #f0f0f0',
                    opacity: comment.isDeleted ? 0.5 : 1,
                  }}>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      marginBottom: '8px',
                    }}>
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                      }}>
                      <span style={{ fontWeight: 'bold' }}>
                        {utils.getNameInCapitalize(getNameUppercaseByUsername(comment.feedbackUsername))}:
                      </span>
                      {comment.isDeleted && (
                        <Tag
                          color="red"
                          style={{ fontSize: '10px', margin: 0 }}>
                          Đã xóa
                        </Tag>
                      )}
                    </div>
                    <span style={{ color: 'gray', fontSize: '12px' }}>
                      {new Date(comment.createdAt).toLocaleDateString('vi-VN', {
                        weekday: 'long',
                        day: '2-digit',
                        month: 'long',
                        year: 'numeric',
                      })}{' '}
                      {new Date(comment.createdAt).toLocaleTimeString('vi-VN', {
                        hour: '2-digit',
                        minute: '2-digit',
                      })}
                    </span>
                  </div>

                  <div
                    style={{ margin: 0, color: '#000', paddingLeft: '4px' }}
                    dangerouslySetInnerHTML={{
                      __html: comment.detailFeedbackComment,
                    }}
                  />

                  {comment.attachedFiles && !comment.isDeleted && (() => {
                    try {
                      const files = JSON.parse(comment.attachedFiles)
                      if (!files || files.length === 0) return null
                      return (
                        <div
                          style={{
                            marginTop: '8px',
                            paddingTop: '8px',
                            paddingLeft: '4px',
                          }}>
                          {files.map((f, i) => (
                            <FileItem
                              key={`${f.fileId}-${i}`}
                              file_id={f.fileId}
                              file_name={f.fileName}
                              file_type={f.fileName ? f.fileName.split('.').pop().toLowerCase() : ''}
                              style={{ marginBottom: '4px' }}
                            />
                          ))}
                        </div>
                      )
                    } catch (e) {
                      return null
                    }
                  })()}
                </div>
              )
            })
          ) : (
            <div
              style={{
                textAlign: 'center',
                color: '#999',
                padding: '20px',
                fontStyle: 'italic',
              }}>
              Chưa có ý kiến nào.
            </div>
          )}
        </div>
      </div>
    </ContentBlockWrapper>
  )
}

export default inject(
  'FeedbackCommentStore',
  'fileStore',
  'loadingAnimationStore'
)(observer(FeedbackCommentSection))
